import {
    GET_COLLECTION_STARTED,
    GET_COLLECTION_SUCCESS,
    GET_COLLECTION_FAILED,
} from "./collectionConstants";

const initialState = {
    collections: {},
    loading: false,
    error: null,
};

export default function collectionReducer(state = initialState, { type, payload }) {
    switch (type) {
        case GET_COLLECTION_STARTED:
            return {
                ...state,
                loading: true,
            };
        case GET_COLLECTION_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                collections: payload.collections.collections,
            };
        case GET_COLLECTION_FAILED:
            return {
                ...state,
                loading: false,
                error: payload.error,
            };
        default: {
            return state;
        }
    }
}
